import React, { useEffect, useState } from 'react';
import { Button, Form, Header, Icon, Modal, TextArea } from 'semantic-ui-react';

interface Props {
    open: boolean;
    onClose: () => void;
    onSubmit: (reason?: string) => void;
    loading?: boolean;
    /** e.g. 'post' or 'comment' — used in the header and prompt copy. */
    contentLabel: string;
}

const MAX_REASON_LENGTH = 500;

const ReportContentModal = ({ open, onClose, onSubmit, loading = false, contentLabel }: Props) => {
    const [reason, setReason] = useState('');

    // Each open is a fresh report (possibly on a different item) — don't carry over
    // whatever was typed for a previous one.
    useEffect(() => {
        if (open) setReason('');
    }, [open]);

    const handleSubmit = () => onSubmit(reason.trim() || undefined);

    return (
        <Modal
            open={open}
            onClose={onClose}
            size="small"
            closeOnDimmerClick={!loading}
            centered
            className="report-content-modal"
        >
            <Header icon="flag" content={`Report this ${contentLabel}`} />
            <Modal.Content>
                <Form>
                    <Form.Field>
                        <TextArea
                            value={reason}
                            onChange={(_, { value }) => setReason(String(value ?? '').slice(0, MAX_REASON_LENGTH))}
                            placeholder="Let us know what's wrong (optional)"
                            maxLength={MAX_REASON_LENGTH}
                            rows={3}
                            disabled={loading}
                            autoFocus
                        />
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose} disabled={loading}>
                    <Icon name="remove" /> Cancel
                </Button>
                <Button color="orange" onClick={handleSubmit} loading={loading} disabled={loading}>
                    <Icon name="flag" /> Report
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default ReportContentModal;
